<template>
	<div class="trnt-block p5" style="border-radius: 5px 5px 0px 0px;margin-top: 2px;margin-bottom: 2px;">
		<center>
			<img style="max-width:390px;width:100%;border-radius:9px;" w:id="logo" src="@/assets/img/logo.png" />
		</center>
		<div class="green1 small bold">Добро пожаловать в хитовую онлайн-игру!</div>
		<div class="white small bold">
			<img src="@/assets/img/icons/online.png"> более 50 танков в игре;
			<br><img src="@/assets/img/icons/online.png"> 4 нации и премиум танки;
			<br><img src="@/assets/img/icons/online.png"> бои и сражения по уровням техники;
			<br><img src="@/assets/img/icons/online.png"> модули и оборудование для танков;
			<br><img src="@/assets/img/icons/online.png"> кланы, в которых есть здания;
			<br><img src="@/assets/img/icons/online.png"> ежедневные и одноразовые задания;
			<br><img src="@/assets/img/icons/online.png"> исторические спецзадания;
			<br><img src="@/assets/img/icons/online.png"> при регистрации аватарка в подарок.
			<br>
		</div>
		<div class="green1 small bold">Заходи и будь первым в мире танков!</div>
	</div>
	<table>
		<tr>
			<td class="w50">
				<a class="simple-but border" style="border: 0px white;border-radius:3px;margin-top: 2px;margin-bottom: 2px; " href="/reg"><span><span>Начать игру</span></span></a>
			</td>
			<td class="w50">
				<a class="simple-but border" style="border: 0px white;border-radius:3px;margin-top: 2px;margin-bottom: 2px; " href="/pass"><span><span>Забыл пароль</span></span></a>
			</td>
		</tr>
	</table>
	<div class="trnt-block white medium" style="padding:5px;border-radius:0px 0px 5px 5px;">
		<center>
			<div class="small bold green1">
				<span class="white">Онлайн:</span> 0
			</div>
		</center>
		<form method='post'>
			<div class="wrap-content">
				<div class="white small sh_b bold mb10">
					<center>
						<table style="text-align:center;">
							<tr>
								<td>
									<input type="text" name="nick" value="" class="gray cntr" size="20" placeholder="Ник" maxlength="32">
								</td>
							</tr>
							<tr>
								<td>
									<input type="password" name="pass" value="" class="gray cntr" size="20" placeholder="Пароль" maxlength="32">
								</td>
							</tr>
						</table>
						<div class="bot">
							<span class="input-but border" style="border:2px solid black;border-radius:4px;"><span><input class="w100" name="vhod" type="submit" value="Войти" /></span></span>
						</div>
					</center>
				</div>
			</div>
		</form>
	</div>
	
	<!--
	<div class="d-flex align-items-center min-vh-100 overflow-hidden">
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4">
					<div class="animate__animated animate__fadeIn">
						<div class="position-relative text-center text-white mb-5">
							<img src="@/assets/img/logo.png" class="w-50 mb-3" />
							<h4 class="mb-0">
								<strong>ЗАЧИСТКА ПОДЗЕМЕЛЬЯ</strong>
							</h4>
						</div>
						<div class="card">
							<div class="card-body text-center">
								<div class="d-grid gap-2">
									<router-link :to="{path: '/game', query: {u: username}}" class="btn btn-lg btn-success">Играть</router-link>
									<router-link :to="{path: '/instructions', query: {u: username}}" class="btn btn-lg btn-primary">Инструкции</router-link>
									<router-link :to="{path: '/results', query: {u: username}}" class="btn btn-lg btn-primary">Результаты</router-link>
									<router-link :to="{path: '/logout'}" class="btn btn-lg btn-secondary mt-3" v-if="authModel.isAuth()">Выйти</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	-->
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'TankOn2'});
	},
	data: () => ({
		username: '',
    }),
    methods: {
		redirectToAuth(){
			const redirectUri = window.location.origin;
			const authUrl = 'https://id.bylex.su/login-out?' + new URLSearchParams({
				redirect: redirectUri,
			});
			window.location.href = authUrl;
		},
	},
	mounted(){
		if(this.$route.query.u) this.username = this.$route.query.u;
		else this.username = this.authModel.getLogin();
		
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		if(to.query.u != this.username) this.username = to.query.u || '';
		else this.username = this.authModel.getLogin();
		
		window.scrollTo(0, 0);
		next();
	},
	components: {},
}
</script>